/**
 * Default Values Constants
 * Standard default values for analytics tracking parameters
 */

export const DEFAULT_VALUES = {
  /** Default step number for single-page forms */
  STEP: "1",
  /** Default page load value (false = click action) */
  PAGE_LOAD: "false",
  /** Numeric one as string for question index */
  NUMBER_ONE: "1",
  /** Yes value for boolean fields */
  YES: "yes",
  /** No value for boolean fields */
  NO: "no",
} as const;

export type DefaultValueType =
  (typeof DEFAULT_VALUES)[keyof typeof DEFAULT_VALUES];
